export enum IntensitiesAction {
  UPDATE_INTENSITIES = "UPDATE_INTENSITIES",
}

export type Intensity = {
  pos: number;
  name: string;
};

export type IntensityUI = Intensity & {
  id: string;
  isEditable: boolean;
};

export interface IntensitiesState {
  teamsById: Record<string, Intensity[]>;
}

export interface UpdateIntensitiesAction {
  type: IntensitiesAction.UPDATE_INTENSITIES;
  data: Record<string, Intensity[]>;
}

export type TeamIntensities = {
  teamId: string;
  intensities: Intensity[];
};

export type IntensitiesActions = UpdateIntensitiesAction;
